import { Styles } from '@monkvision/types';

export const styles: Styles = {
  downloadPicturesButton: {
    borderRadius: '5px',
    width: 'fit-content',
  },
};
